import { Component, ElementRef, HostListener, OnInit, ViewChild } from '@angular/core';
import { Requiredaction } from 'src/app/models/auth/user';
import { AuthenticationService } from 'src/app/services/authentication.service';
import { ResActionsService } from './ResActions.service';
import { AttendenceComponent } from 'src/app/features/auth/attendance/attendence.component';
import { MatDialog } from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';
import { TillAmountConfirmComponent } from './components/till-amount-confirm/till-amount-confirm.component';

@Component({
  selector: 'app-actions-bar',
  templateUrl: './actions-bar.component.html'
})
export class ActionsBarComponent implements OnInit {
  isActive = false;
  restaurantId = localStorage.getItem('restaurantId');

  actionLoader: string | null = null;
  actionsPermissions: any;
  requiredaction = Requiredaction;

  constructor(
    public authenticationService: AuthenticationService,
    public dialog: MatDialog,
    private service: ResActionsService,
    private translate: TranslateService
  ) { }

  ngOnInit(): void {
    this.getActionsPermissions();
    this.authenticationService.updateActionsPermissions.subscribe((data) => {
      if (data) {
        this.getActionsPermissions();
      }
    })
  }

  get showActionsBar() {
    return (
      this.actionsPermissions
      && (
        this.actionsPermissions.canPrintTill
        || (
          this.actionsPermissions.currentRestaurantAction.requiredaction == Requiredaction.ClockOut
          && this.actionsPermissions.currentRestaurantAction.attendancefeature
        )
      )
    )
  }

  getActionsPermissions() {
    if (this.restaurantId) {
      this.authenticationService.getActionsPermissions(this.restaurantId).subscribe(
        result => {
          this.authenticationService.actionsPermissions.next(result);
          this.actionsPermissions = result;
        }, err => {
          console.error(err);
        });
    }
  }

  clockout() {
    const dialogRef = this.dialog.open(AttendenceComponent, {
      width: '400px',
      data: {
        action: Requiredaction.ClockOut,
        restaurantId: this.restaurantId
      }
    });
    // dialogRef.afterClosed().subscribe(result => {
    //   if (result && this.actionsPermissions.canPrintTill) {
    //     setTimeout(() => { this.print(result.htmlContent); }, 500);
    //   }
    // });
  }

  openTillAmount() {
    const dialogRef = this.dialog.open(TillAmountConfirmComponent, {
      width: '400px',
      data: {
        isOwner: this.actionsPermissions.canShowBranch,
        restaurantId: this.restaurantId
      }
    });
    // dialogRef.afterClosed().subscribe(result => {
    //   if (result) {
    //     this.printTill(result);
    //   }
    // });
  }

  print(html: string): void {
    const mywindow: any = window.open('', 'PRINT', 'height=600,width=700');
    mywindow.document.write(html);

    mywindow.document.close();
    mywindow.focus();

    mywindow.onload = () => {
      mywindow.print();
    };
  }

  @ViewChild("actionsContainer") actionsContainer!: ElementRef;
  @HostListener('document:click', ['$event']) clickout(event: any) {
    if (
      this.showActionsBar
      && !this.actionsContainer.nativeElement.contains(event.target)
      && !event.target.classList.contains('mat-icon')
    ) {
      this.isActive = false;
    }
  }
}
